import React from 'react';

interface IProps {
  text: string | React.ReactNode;
  type: 'danger' | 'default' | 'filled' | 'gray' | 'update' | 'back' | 'delete';
  buttonType?: 'button' | 'submit' | 'reset';
  onClick?: () => void;
  icon?: React.ReactNode; // ✅ іконка
  disabled?: boolean;
}

export const SmallButton = ({
  text,
  type,
  buttonType,
  onClick,
  icon,
  disabled
}: IProps) => {
  const classes = {
    gray: 'border-gray-500 text-gray-500 hover:border-blue-400 hover:text-blue-400 active:text-blue-700 active:border-blue-700',
    danger:
      'border-gray-500 text-gray-500 hover:border-red-500 hover:text-red-500 active:bg-hover:text-red-500 active:bg-rose-100',
    default:
      'border-blue-600 text-blue-600  hover:border-blue-400 hover:text-blue-400 active:text-blue-700 active:border-blue-700',
    filled:
      'rounded-[32px] border border-blue-600 bg-blue-500 text-black font-body hover:outline-none hover:ring-4 hover:ring-[rgba(93,225,255,0.20)] hover:bg-blue-600',
    update:
      'bg-base-black text-surface-secondary-alt rounded-[32px] w-[235px] h-[52px] hover:shadow-[0_0_0_4px_rgba(93,225,255,0.20)]',
    back: 'w-[135px] h-[52px] rounded-[32px] border border-gray-500 bg-gray-400 text-surface-secondary-alt hover:shadow-[0_0_0_4px_rgba(93,225,255,0.20)]',
    delete: 'text-surface-base rounded-[32px] w-[235px] h-[52px] bg-red-500'
  };

  let width = 'min-w-fit';
  if (typeof text === 'string') {
    width = 'w-56';
  }

  return (
    <button
      onClick={disabled ? undefined : onClick}
      type={buttonType || 'button'}
      disabled={disabled}
      className={`border-2 rounded-[32px] px-4 py-2 flex items-center justify-center gap-[6px] ${classes[type]} ${width} ${disabled ? 'opacity-60 cursor-not-allowed' : ''}`}
    >
      {icon && <span className="flex items-center">{icon}</span>}
      <span>{text}</span>
    </button>
  );
};
